import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { KitComponentInput, KitComponents } from '../interfaces/inventory/kit.interface';

/** F6c: kit components (GET: STOCK_VIEW or SALES_ORDER_VIEW; PUT: ITEM_MANAGE). */
export const KitService = {
  get: async (institutionId: string, kitItemId: string, storeId?: string | null): Promise<KitComponents> =>
    (await axios.get(ENDPOINTS.KIT.COMPONENTS(institutionId, kitItemId), { params: storeId ? { storeId } : {} })).data,
  replace: async (institutionId: string, kitItemId: string, components: KitComponentInput[]): Promise<KitComponents> =>
    (await axios.put(ENDPOINTS.KIT.COMPONENTS(institutionId, kitItemId), { components })).data,
};
